<template>
  <g>
    <g clip-path="url(#clip0_15_650)">
      <path
        d="M17 0.000183105H7C5.9 0.000183105 5 0.900183 5 2.00018V16.0002C5 17.1002 5.9 18.0002 7 18.0002H17C18.1 18.0002 19 17.1002 19 16.0002V2.00018C19 0.900183 18.1 0.000183105 17 0.000183105ZM17 12.5002C17 10.8302 13.67 10.0002 12 10.0002C10.33 10.0002 7 10.8302 7 12.5002V3.00018C7 2.45018 7.45 2.00018 8 2.00018H16C16.55 2.00018 17 2.45018 17 3.00018V12.5002ZM10.85 18.8502C10.54 18.5402 10 18.7602 10 19.2102V20.0002H6C5.45 20.0002 5 20.4502 5 21.0002C5 21.5502 5.45 22.0002 6 22.0002H10V22.7902C10 23.2402 10.54 23.4602 10.85 23.1402L12.64 21.3502C12.84 21.1502 12.84 20.8402 12.64 20.6402L10.85 18.8502ZM18 20.0002H15C14.45 20.0002 14 20.4502 14 21.0002C14 21.5502 14.45 22.0002 15 22.0002H18C18.55 22.0002 19 21.5502 19 21.0002C19 20.4502 18.55 20.0002 18 20.0002ZM12 8.00018C13.1 8.00018 14 7.10018 14 6.00018C14 4.90018 13.1 4.00018 12 4.00018C10.9 4.00018 10.01 4.90018 10.01 6.00018C10.01 7.10018 10.9 8.00018 12 8.00018Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_650">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000183105)"
        />
      </clipPath>
    </defs>
  </g>
</template>
